export enum UserEventType {
  ClickCitation = 'click_citation',
  DarkModeToggled = 'dark_mode_toggled',
  DeleteFiles = 'delete_files',
  EditFiles = 'edit_files',
  FocusOnBrowserTab = 'focus_on_browser_tab',
  OpenClaim = 'open_claim',
  PagedDatapointTable = 'paged_datapoint_table',
  RequestNewClaim = 'request_new_claim',
  SelectDocSegmentFromDrawer = 'select_doc_segment_from_drawer',
  SelectDocSegmentFromFilesList = 'select_doc_segment_from_files_list',
  SelectFile = 'select_file',
  SelectFileToc = 'select_file_toc',
  StopSearch = 'stop_search',
  SwitchClaimTab = 'switch_claim_tab',
}
